import { render, staticRenderFns } from "./navigation-group.vue?vue&type=template&id=af07a104&scoped=true"
import script from "./navigation-group.vue?vue&type=script&lang=js"
export * from "./navigation-group.vue?vue&type=script&lang=js"
import style0 from "./navigation-group.vue?vue&type=style&index=0&id=af07a104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af07a104",
  null
  
)

export default component.exports